







































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { Scroller } from '@lx-frontend/cvux'
import { ActivityItem, ActivityStatusEnum, ShareOptions } from '@/modules/marketing/activity/types'
import { ActivityStatusFilter, numberFormatWithUnit } from '@/modules/marketing/activity/config'
import ShareAppMessage from './component/shareAppMessage/shareAppMessage.vue'

@Component({
  components: {
    Scroller,
    ShareAppMessage
  },
  filters: {
    ActivityStatusFilter,
    numberFormatWithUnit
  }
})
export default class ActivityCenter extends Vue {
  @Ref('scrollerRef') readonly scrollerRef!: {
    reset: () => void;
    enablePullup: () => void;
    disablePullup: () => void;
  }

  activityList: ActivityItem[] = []

  queryForm = {
    page: 1,
    count: 10,
    total: 0
  }

  pullConfig = {
    content: '',
    downContent: '',
    upContent: '',
    loadingContent: '加载中...'
  }

  showShare = false

  shareOptions:ShareOptions = {
    title: '',
    abstract: '',
    own_url: '',
    image_url: ''
  }

  get activityStatusEnum() {
    return ActivityStatusEnum
  }

  mounted() {
    this.getData()
    this.setHideItems()
  }

  handleToCustomer(id: number) {
    this.$router.push({
      path: `/marketing/activityCustomer/${id}`
    })
  }

  /**
   * 隐藏复制按钮
   */
  setHideItems() {
    const menuItems = [
      'menuItem:editTag',
      'menuItem:delete',
      'menuItem:copyUrl',
      'menuItem:originPage',
      'menuItem:readMode',
      'menuItem:openWithQQBrowser',
      'menuItem:openWithSafari',
      'menuItem:share:email',
      'menuItem:share:brand',
      'menuItem:favorite',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:share:qq'
    ]
    // @ts-ignore
    this.$wechat.promise.then(wx => {
      // 处理分享到朋友圈
      wx.hideMenuItems({
        menuItems
      })
      // wx.shareWechat(opt)
    }, (wx: { res: any; }) => {
      // 抛出异常
      throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
    })
  }

  /**
   * 获取报名列表数据
   */
  async getData() {
    const { code, data } = await this.$rest.marketing.getActivityList({ ...this.queryForm })
    if (code === 0) {
      this.activityList.push(...data.activities)
      this.queryForm.total = data.total
      this.$nextTick(() => {
        this.scrollerRef.reset()
      })
    }
    this.$nextTick(() => {
      this.scrollerRef.enablePullup()
    })
  }

  /**
   * 加载
   * @param done
   */
  async loadMore(done: (time?:number) => void) {
    if ((this.queryForm.page * this.queryForm.count) < this.queryForm.total) {
      ++this.queryForm.page
      await this.getData()
      done()
    } else {
      this.$nextTick(() => {
        this.scrollerRef.reset()
        this.scrollerRef.disablePullup()
      })
      done()
    }
  }

  isDisableShare(row: ActivityItem) {
    return row.status === ActivityStatusEnum.Stopped
  }

  /**
   * 获取分享链接
   * @param row
   */
  async getActivityShareUrl(row: ActivityItem) {
    if (this.isDisableShare(row)) return
    if (!row.shareData) {
      const { code, data } = await this.$rest.marketing.createShareUrl({ activity_id: row.id })
      if (code === 0) {
        this.shareOptions = { ...data, title: row.title }
        row.shareData = { ...this.shareOptions }
      }
    }
    this.showShare = true
  }

  toRank(id: number) {
    this.$router.push({
      path: `/marketing/activityRank/${id}`
    })
  }
}
